import Fetch from "./index";

export const createSession = async (chatbot, model, generative = false, seed_session = "") => {
  let route = '/dialog-manager-proxy/';
  let data = { chatbot: parseInt(chatbot), snapshot_version: model }

  if (generative) {
    route = '/generative-dialog-manager-proxy/';
    data.seed_session = seed_session
    data.assistant_id = data.chatbot;
    delete data.snapshot_version;
    delete data.chatbot;
  }

  return Fetch(
    route,
    {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
}

export const updateSession = async (
  id,
  message,
  generative = false,
  fileList,
  isDebug = false,
  client_data = {},
  channel = 'API',
  sessionSettings = { ignore_trigger_response: false, force_trigger_call: false }
) => {
  let route = '/dialog-manager-proxy/';
  if (generative) route = '/generative-dialog-manager-proxy/';

  let request = {
    method: 'PUT',
    body: JSON.stringify({
      message,
      client_data,
      channel,
      ignore_trigger_response: sessionSettings.ignore_trigger_response,
      force_trigger_call: sessionSettings.force_trigger_call
    }),
    headers: {
      "Content-Type": "application/json",
    }
  }

  if (fileList) {
    const body = new FormData();
    body.set("message", message);
    if (client_data && Object.keys(client_data).length > 0) {
      body.set('client_data', JSON.stringify(client_data));
    }
    body.set("channel", channel);
    body.set("ignore_trigger_response", sessionSettings.ignore_trigger_response);
    body.set("force_trigger_call", sessionSettings.force_trigger_call);
    for (const fileKey in fileList) {
      let fileType = fileList[fileKey].type.split("/")[0];
      if (fileType === "image" && message === "") {
        body.set("message", "Segue a imagem");
      }
      body.set(`file_${fileKey}`, fileList[fileKey]);
    }
    delete request.headers['Content-Type'];
    request.body = body;
  }

  return Fetch(
    route + id + "?debug=" + isDebug,
    request
  );
}

export const deleteSessionMessages = (sessionId, ids = []) => {
  let route = `/generative-dialog-manager-proxy/${sessionId}/message`;

  return Fetch(
    route,
    {
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ids)
    },
  )
}
